import { Capacitor } from '@capacitor/core';
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';

const useWeb = Capacitor.getPlatform() === 'web';

export const SecureStorage = {
    async saveTokens(access: string, refresh: string) {
        if (useWeb) {
            localStorage.setItem('access_token', access);
            localStorage.setItem('refresh_token', refresh);
        } else {
            await SecureStoragePlugin.set({ key: 'access_token', value: access });
            await SecureStoragePlugin.set({ key: 'refresh_token', value: refresh });
        }
    },

    async getTokens() {
        try {
            if (useWeb) {
                const access = localStorage.getItem('access_token');
                const refresh = localStorage.getItem('refresh_token');
                return { access, refresh };
            } else {
                const access = (await SecureStoragePlugin.get({ key: 'access_token' })).value;
                const refresh = (await SecureStoragePlugin.get({ key: 'refresh_token' })).value;
                return { access, refresh };
            }
        } catch {
            return { access: null, refresh: null };
        }
    },

    async saveUser(user: any) {
        if (useWeb) {
            localStorage.setItem('user', JSON.stringify(user));
        } else {
            await SecureStoragePlugin.set({ key: 'user', value: JSON.stringify(user) });
        }
    },

    async getUser() {
        try {
            if (useWeb) {
                const raw = localStorage.getItem('user');
                return raw ? JSON.parse(raw) : null;
            } else {
                const raw = (await SecureStoragePlugin.get({ key: 'user' })).value;
                return JSON.parse(raw);
            }
        } catch {
            return null;
        }
    },

    async clear() {
        if (useWeb) {
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('user');
        } else {
            await SecureStoragePlugin.clear();
        }
    }
};
